import ActionType from 'store/_utils/classes/ActionType';

import type IActionType from 'store/_utils/interfaces/IActionType';

class NewzzTypes {
  static listNewzz: IActionType = new ActionType('NEWZZ/LIST');
  static loadNewzz: IActionType = new ActionType('NEWZZ/LOAD');
  static clickNewzz: IActionType = new ActionType('NEWZZ/CLICK_NEWZZ');
}

export default NewzzTypes;
